import { render, staticRenderFns } from "./pages.vue?vue&type=template&id=137a95a0&scoped=true&"
import script from "./pages.vue?vue&type=script&lang=js&"
export * from "./pages.vue?vue&type=script&lang=js&"
import style0 from "./pages.vue?vue&type=style&index=0&id=137a95a0&scoped=true&lang=css&"
import style1 from "./pages.vue?vue&type=style&index=1&id=137a95a0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a95a0",
  null
  
)

export default component.exports